import all from '../../../../imgs/icons/all.png';
import alls from '../../../../imgs/icons/alls.png';
import cesuo from '../../../../imgs/icons/cesuo.png';
import cesuos from '../../../../imgs/icons/cesuos.png';
import cheliang from '../../../../imgs/icons/cheliang.png';
import cheliangs from '../../../../imgs/icons/cheliangs.png';
import fuyanglizi from '../../../../imgs/icons/fuyanglizi.png';
import fuyanglizis from '../../../../imgs/icons/fuyanglizis.png';
import guangbo from '../../../../imgs/icons/guangbo.png';
import guangbos from '../../../../imgs/icons/guangbos.png';
import keliuliang from '../../../../imgs/icons/keliuliang.png';
import keliuliangs from '../../../../imgs/icons/keliuliangs.png';
import pm from '../../../../imgs/icons/pm.png';
import pms from '../../../../imgs/icons/pms.png';
import qiya from '../../../../imgs/icons/qiya.png';
import qiyas from '../../../../imgs/icons/qiyas.png';
import shexinagtou from '../../../../imgs/icons/shexiangtou.png';
import shexinagtous from '../../../../imgs/icons/shexiangtous.png';
import shidu from '../../../../imgs/icons/shidu.png';
import shidus from '../../../../imgs/icons/shidus.png';
import sos from '../../../../imgs/icons/sos.png';
import soss from '../../../../imgs/icons/soss.png';
import wendu from '../../../../imgs/icons/wendu.png';
import wendus from '../../../../imgs/icons/wendus.png';
import wifi from '../../../../imgs/icons/wifi.png';
import wifis from '../../../../imgs/icons/wifis.png';
import wuzi from '../../../../imgs/icons/wuzi.png';
import wuzis from '../../../../imgs/icons/wuzis.png';
import arrow from '../../../../imgs/icons/arrow.svg';
import bubble1 from '../../../../imgs/bubble1.png';
import bubble3 from '../../../../imgs/bubble3.png';
import bubble from '../../../../imgs/bubble.png';
import point from '../../../../imgs/bubbleIcons/point.png';
import geologybg from '../../../../imgs/upMapIcons/geologybg.png';
import geologybg2 from '../../../../imgs/upMapIcons/geologybg2.png';
import Environmentbg from '../../../../imgs/upMapIcons/Environmentbg.png';
import carbg from '../../../../imgs/upMapIcons/carbg.png';
import customerbg from '../../../../imgs/upMapIcons/customerbg.png';
import fylzbg from '../../../../imgs/upMapIcons/fylzbg.png';
import mdjcbg from '../../../../imgs/upMapIcons/mdjcbg.png';
import PM from '../../../../imgs/upMapIcons/PM.png';
import qybg from '../../../../imgs/upMapIcons/qybg.png';
import sd from '../../../../imgs/upMapIcons/sd.png';
import toiletbg from '../../../../imgs/upMapIcons/toiletbg.png';
import wdbg from '../../../../imgs/upMapIcons/wdbg.png';
import camera from '../../../../imgs/icons/camera.png';
import led from '../../../../imgs/icons/led.png';
import broadcast from '../../../../imgs/icons/broadcast.png';
import sos2 from '../../../../imgs/icons/sos 2.png';
import wifi2 from '../../../../imgs/icons/wifi 2.png';
import leddis from '../../../../imgs/icons/1.png';
import cameradis from '../../../../imgs/icons/2.png';
import broadcastdis from '../../../../imgs/icons/3.png';
import sosdis from '../../../../imgs/icons/4.png';
import wifidis from '../../../../imgs/icons/5.png';

export const shebeiIcons = {
    camera: {
        0: cameradis,
        1: camera
    },
    led: {
        0: leddis,
        1: led
    },
    broadcast: {
        0: broadcastdis,
        1: broadcast
    },
    sos: {
        0: sosdis,
        1: sos2
    },
    wifi: {
        0: wifidis,
        1: wifi2
    }
}

export const icons = {
    all,
    alls,
    cesuo,
    cesuos,
    cheliang,
    cheliangs,
    fuyanglizi,
    fuyanglizis,
    guangbo,
    guangbos,
    keliuliang,
    keliuliangs,
    pm,
    pms,
    qiya,
    qiyas,
    shexinagtou,
    shexinagtous,
    shidu,
    shidus,
    sos,
    soss,
    wendu,
    wendus,
    wifi,
    wifis,
    wuzi,
    wuzis,
    arrow,
    bubble1,
    bubble,
    bubble3,
    point,
    geologybg,
    geologybg2,
    Environmentbg,
    carbg,
    customerbg,
    fylzbg,
    mdjcbg,
    PM,
    wdbg,
    toiletbg,
    sd,
    qybg
}

export const criteria = {
    liuliang:[
        {
            name: "全部",
            type: undefined,
            defaultIcon: all,
            selectIcon: alls
        },
        {
            name: "客流监测",
            type: "keliujiance",
            defaultIcon: keliuliang,
            selectIcon: keliuliangs
        },
        {
            name: "密度监测",
            type: "midujiance",
            defaultIcon: wuzi,
            selectIcon: wuzis
        },
        {
            name: "停车场",
            type: "tingchechang",
            defaultIcon: cheliang,
            selectIcon: cheliangs
        },
        {
            name: "智能厕所",
            type: "zhinengcesuo",
            defaultIcon: cesuo,
            selectIcon: cesuos
        }
    ],
    tongxun:[],
    huanjing:[
        {
            name: "温度",
            type: "wendu",
            defaultIcon: wendu,
            selectIcon: wendus
        },
        {
            name: "湿度",
            type: "shidu",
            defaultIcon: shidu,
            selectIcon: shidus
        },
        {
            name: "气压",
            type: "qiya",
            defaultIcon: qiya,
            selectIcon: qiyas
        },
        {
            name: "负氧离子",
            type: "fuyanglizi",
            defaultIcon: fuyanglizi,
            selectIcon: fuyanglizis
        },
        {
            name: "PM2.5",
            type: "pm25",
            defaultIcon: pm,
            selectIcon: pms
        },
        {
            name: "PM10",
            type: "pm10",
            defaultIcon: pm,
            selectIcon: pms
        }
    ],
    shebei:[
        {
            name: "全部",
            type: undefined,
            defaultIcon: all,
            selectIcon: alls
        },
        {
            name: "摄像头",
            type: "camera",
            defaultIcon: shexinagtou,
            selectIcon: shexinagtous,
        },
        {
            name: "LED",
            type: "led",
            defaultIcon: wuzi,
            selectIcon: wuzis,
        },
        {
            name: "广播",
            type: "broadcast",
            defaultIcon: guangbo,
            selectIcon: guangbos,
        },
        {
            name: "SOS",
            type: "sos",
            defaultIcon: sos,
            selectIcon: soss,
        },
        {
            name: "WIFI",
            type: "wifi",
            defaultIcon: wifi,
            selectIcon: wifis,
        }
    ],
    dizhi:[

    ],
    xiangmu:[
        {
            name: "全部",
            type: undefined,
            defaultIcon: all,
            selectIcon: alls
        }, 
        {
            name: "客流监测",
            type: "keliujiance",
            defaultIcon: keliuliang,
            selectIcon: keliuliangs
        },
        {
            name: "密度监测",
            type: "midujiance",
            defaultIcon: wuzi,
            selectIcon: wuzis
        },
        {
            name: "停车场",
            type: "tingchechang",
            defaultIcon: cheliang,
            selectIcon: cheliangs
        },
        {
            name: "智能厕所",
            type: "zhinengcesuo",
            defaultIcon: cesuo,
            selectIcon: cesuos
        }
    ],
    tuzhi:[]
}

export default {
    TaskStatus:{
        Todo:{
            code:"0",
            desc:"未处理"
        },
        Processing:{
            code:"1",
            desc:"执行中"
        },
        Done:{
            code:"2",
            desc:"已完成"
        },
        Exception:{
            code:"3",
            desc:"异常"
        },
        Closed:{
            code:"4",
            desc:"关闭"
        }
    }
};

export const peoples=[
    {
        name:"语音对讲1",
        id:"liming",
        department:"综合执法处",
        longitude:88.07353,
        latitude:43.972541
    },
    {
        name:"语音对讲2",
        id:"liuxing",
        department:"综合执法处",
        longitude:88.073747,
        latitude:44.108938
    },
    {
        name:"语音对讲3",
        id:"xiaxue",
        department:"综合执法处",
        longitude:88.10613,
        latitude:43.953225
    },
    {
        name:"语音对讲4",
        id:"xiajiang",
        department:"综合执法处",
        longitude:88.125312,
        latitude:43.919021
    }
]